import { consumeLoading } from "@/lib/consume/loading"
import { consumeRouter } from "@/lib/consume/router"
import { GeolocationContainerComponent } from "@/lib/geolocation/container/component"
import { Notices } from "@/lib/notices"

export const GeolocationContainerConsumer = consumeLoading(
  consumeRouter(Notices.consumeFunctions(GeolocationContainerComponent))
)
